export class Utente {
  id;
  nome;
  cognome;
  codiceFiscale;
  email;
  emailIstituzionale;
  telefono;
  telefonoIstituzionale;

  nuovaReferenza;
  nuovoEnte;

  ruoli;
  comuni;
}
